// import '../style.scss';
// import './style.scss';
import { Button, ButtonFill, ButtonSize, ButtonType } from 'views/mutual/button';
import { Caption } from 'views/mutual/caption';
import { useCorporateAccountOpenProfileDetailsPageTypeStore } from 'views/pages/accountOpenProfileDetails/corporateProfileDetails/hooks';
import { FormContentHeader, FormType } from 'views/templates/module/contentHeader';
import { AuthModeSelectType, useTFAuthentication } from './hooks';
import { MultiSelections } from 'views/mutual/inputRadio';
import { TemplateProps } from '../common';
import { useCustomLocationName } from 'views/mutual/location/hooks';

export type TFAuthenticationProps = {
  formik: any;
  authModeProps: any;
};

export const TFAuthenticationWrapper = () => {
  return <TFAuthentication {...useTFAuthentication({ isUpdate: false })} />;
};

export const TFAuthentication = ({
  formik,
  authModeProps,
  isUpdate,
}: TFAuthenticationProps & TemplateProps) => {
  const { setAccountOpenProfileDetailsPageType, previousPage } = useCorporateAccountOpenProfileDetailsPageTypeStore();

  useCustomLocationName('口座開設');

  return (
    <form onSubmit={formik.handleSubmit} className="accountOpenTemplate">
      {!isUpdate && (
        <>
          <Caption label="2段階認証" />
        </>
      )}
      <div className="accountOpenTemplate_input">

        <FormContentHeader label={
          <>
          口座開設後のログインには、セキュリティを強化するための2段階認証が必要となります。<br/>
          2段階認証は、以下のいずれかの方法をお選びいただけます。
          </>
          } formType={FormType.Required} />
        <div className="accountOpenTemplate_input_check">
          <MultiSelections
            items={[
              {
                label: 'SMSによる認証　　※取引担当者様の携帯電話番号に送信されるSMSメッセージを使用して認証します',
                value: AuthModeSelectType.SMS,
              },
              { label: 'メールによる認証　　※取引担当者様のメールアドレスに送信されるメールを使用して認証します',
                value: AuthModeSelectType.MailAddress,
              },
            ]}
            name="ConfirmAddress"
            {...authModeProps}
          />
        </div>        
      </div>

      {!isUpdate && (
        <div className="accountOpenTemplate_button">
          <Button type={ButtonType.Submit} label="次へ" buttonFill={ButtonFill.black} buttonSize={ButtonSize.medium} />
          <Button
            label="前の画面に戻る"
            buttonFill={ButtonFill.link}
            buttonSize={ButtonSize.small}
            onClick={() => setAccountOpenProfileDetailsPageType(previousPage)}
          />
        </div>
      )}
    </form>
  );
};
